import React from 'react'
import '../style/page_05.scss'
import { CSSTransition } from 'react-transition-group'
function Page05(props) {
  return (
    <div className="page page_05">
      <div className="title"></div>
      <div className="chara-info-container">
        {[1, 2, 3, 4].map(num => (
          <CSSTransition in={props.activeBannerIndex === num} classNames="fade" timeout={500} key={num} className="chara-info" >
            <div>
              <div className="image"></div>
              <div className="name"></div>
              <div className="line"></div>
            </div>
          </CSSTransition>
        ))}
      </div>
      <div className="tab-icon-container">
        {
          [1, 2, 3, 4].map(num => (
            <div key={num} className={[`chara-icon chara-icon-${num}`, (props.activeBannerIndex === num ? 'active' : '')].join(' ')} data-index={num} onClick={props.handleBannerClick}><div className="inner"></div></div>
          ))
        }
      </div>
      {/* <div data-direction="-1" onClick={props.handleBannerClick} className="arrow left"></div>
      <div data-direction="1" onClick={props.handleBannerClick} className="arrow right"></div> */}
    </div>
  )
}

export default Page05;
